export enum ChannelState {
  RUNNING = 1,
  PAUSED = 2,
  STOPPED = 3,
  FAULTED = 4,
}
